// File: client/src/components/analytics/MetricSelector.js
import React, { useState } from 'react';
import { Button, Select, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import FilterPill from './FilterPill';

const MetricSelector = ({
                            availableMetrics,
                            selectedMetrics,
                            onMetricAdd,
                            onMetricRemove
                        }) => {
    const [isSelecting, setIsSelecting] = useState(false);

    // When no metric is selected, default to Call Volume.
    const displayMetrics =
        selectedMetrics.length === 0
            ? [{ id: 'volume', label: 'Call Volume', showAverage: false }]
            : selectedMetrics;

    const handleMetricSelect = (metricId) => {
        const metric = availableMetrics.find(m => m.id === metricId);
        if (metric) {
            onMetricAdd(metric);
        }
        setIsSelecting(false);
    };

    const unusedMetrics = availableMetrics.filter(
        metric => !selectedMetrics.some(m => m.id === metric.id)
    );

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <span style={{ color: '#6b7280' }}>Show Metrics:</span>
            <Space size={8} align="center">
                {displayMetrics.map(metric => (
                    <FilterPill
                        key={metric.id}
                        label={metric.label}
                        active={true}
                        onClick={() => metric.id !== 'volume' && onMetricRemove(metric.id)}
                        style={{ cursor: metric.id !== 'volume' ? 'pointer' : 'default' }}
                    />
                ))}
                {unusedMetrics.length > 0 && (
                    isSelecting ? (
                        <Select
                            showSearch
                            open={true}
                            style={{ width: 250 }}
                            dropdownStyle={{ borderRadius: '12px' }}
                            placeholder="Select a metric"
                            onChange={handleMetricSelect}
                            onBlur={() => setIsSelecting(false)}
                            autoFocus
                            options={unusedMetrics.map(metric => ({
                                label: metric.label,
                                value: metric.id
                            }))}
                        />
                    ) : (
                        <Button
                            type="link"
                            icon={<PlusOutlined />}
                            style={{ paddingLeft: 0 }}
                            onClick={() => setIsSelecting(true)}
                        >
                            Add metric
                        </Button>
                    )
                )}
            </Space>
        </div>
    );
};

export default MetricSelector;
